import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'irembogov-hidden-hide-fields-placeholder',
  templateUrl: './hidden-hide-fields-placeholder.component.html',
  styleUrls: ['./hidden-hide-fields-placeholder.component.scss'],
})
export class HiddenHideFieldsPlaceholderComponent {
  @Input() field!: FormlyFieldConfig;
  @Input() descriptionName = 'Field';
  @Output() fieldConfigActionEvent = new EventEmitter();
}
